// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201306/js/" + chunkId + "." + {"44":"7ddfbd9a","225":"0f2bf574","481":"cb2022ed","486":"c4798b3f","770":"4a98be14"}[chunkId] + ".0.8771687505848511.chunk.js";
};